// ------- helpers
function updateZoomIconState(isZoomed) {
  const zoomIcon = document.querySelector('.product-zoom-icon .icon');
  if (!zoomIcon) return;

  const plusPath = zoomIcon.querySelector('path:nth-child(2)');
  const magnifyingGlassPath = zoomIcon.querySelector('path:nth-child(3)');

  if (isZoomed) {
    // Hide plus sign, show magnifying glass (zoom out state)
    if (plusPath) plusPath.style.display = 'none';
    if (magnifyingGlassPath) magnifyingGlassPath.style.display = '';

    // Create minus sign if it doesn't exist
    let minusPath = zoomIcon.querySelector('.minus-path');
    if (!minusPath) {
      minusPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      minusPath.setAttribute('class', 'minus-path');
      minusPath.setAttribute('fill-rule', 'evenodd');
      minusPath.setAttribute('clip-rule', 'evenodd');
      minusPath.setAttribute('d', 'M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z');
      minusPath.setAttribute('fill', 'currentColor');
      zoomIcon.appendChild(minusPath);
    }
    minusPath.style.display = '';
  } else {
    // Show plus sign, hide minus sign (zoom in state)
    if (plusPath) plusPath.style.display = '';
    if (magnifyingGlassPath) magnifyingGlassPath.style.display = '';

    const minusPath = zoomIcon.querySelector('.minus-path');
    if (minusPath) minusPath.style.display = 'none';
  }
}

function createLoadingSpinner() {
  const spinner = document.createElement('div');
  spinner.className = "zoom-overlay__spinner";

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('class', 'spinner');
  svg.setAttribute('viewBox', '0 0 66 66');

  const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle.setAttribute('stroke-width', '6');
  circle.setAttribute('cx', '33');
  circle.setAttribute('cy', '33');
  circle.setAttribute('r', '30');
  circle.setAttribute('fill', 'none');
  circle.setAttribute('class', 'path');

  svg.appendChild(circle);
  spinner.appendChild(svg);

  return spinner;
}

function prepareOverlay(overlayEl, imageEl) {
  overlayEl.setAttribute('class', 'image-magnify-full-size');
  overlayEl.setAttribute('aria-hidden', 'true');
  overlayEl.style.backgroundImage = `url('${imageEl.src}')`;
  overlayEl.style.backgroundRepeat = 'no-repeat';
  overlayEl.style.backgroundColor = "#f2f3f2";
  overlayEl.style.position = 'absolute';
  overlayEl.style.pointerEvents = 'auto';
  overlayEl.style.display = 'none'; // show only when first frame is drawn
}

function positionOverlayOverImage(overlayEl, imageEl) {
  const rect = imageEl.getBoundingClientRect();
  // overlayEl.style.left = `${rect.left}px`;
  // overlayEl.style.top = `${rect.top}px`;
  overlayEl.style.width = `${rect.width}px`;
  overlayEl.style.height = `${rect.height}px`;
}

// ------- core
function createOverlay(imageEl, { mount = 'body' } = {}) {
  const mountTarget = typeof mount === 'string' ? document.querySelector(mount) : mount;
  if (!mountTarget) throw new Error('Overlay mount target not found');

  if( mountTarget.querySelector('.image-magnify-full-size')){
    mountTarget.querySelector('.image-magnify-full-size').remove();
  }
  const overlayEl = document.createElement('div');
  prepareOverlay(overlayEl, imageEl);

  // Show loading spinner
  const spinner = createLoadingSpinner();
  const imageContainer = imageEl.parentElement;
  imageContainer.appendChild(spinner);

  // fade original
  imageEl.style.opacity = '0.5';

  // promise that resolves once appended & positioned
  let resolveReady;
  overlayEl._readyPromise = new Promise((res) => (resolveReady = res));

  const overlayImage = new Image();
  // Use the image element's currentSrc for responsive <img srcset> correctness
  overlayImage.src = imageEl.currentSrc || imageEl.src;

  overlayImage.onload = () => {
    spinner.remove();

    // Update zoom icon to show zoom-out state (hide plus, show minus)
    updateZoomIconState(true);

    mountTarget.appendChild(overlayEl);
    positionOverlayOverImage(overlayEl, imageEl);
    imageEl.style.opacity = '1';
    resolveReady();
  };

  const reposition = () => positionOverlayOverImage(overlayEl, imageEl);
  window.addEventListener('scroll', reposition, { passive: true });
  window.addEventListener('resize', reposition);

  overlayEl._cleanup = () => {
    window.removeEventListener('scroll', reposition);
    window.removeEventListener('resize', reposition);
    overlayEl.remove();
    imageEl.style.opacity = '1';

    // Restore zoom icon to zoom-in state (show plus, hide minus)
    updateZoomIconState(false);

    // Clean up any remaining spinner
    const remainingSpinner = imageContainer.querySelector('.zoom-overlay__spinner');
    if (remainingSpinner) {
      remainingSpinner.remove();
    }

    // Reset global zoom state
    if (window.zoomState && window.zoomState.currentOverlay === overlayEl) {
      window.zoomState.currentOverlay = null;
    }
  };

  return overlayEl;
}

function moveWithHover(overlayEl, imageEl, event, zoomRatio, type='mouse') {
  if (!overlayEl) return;

  const rect = imageEl.getBoundingClientRect();
  // Guard: natural sizes might be 0 if not fully loaded
  const nW = imageEl.naturalWidth || rect.width;
  const nH = imageEl.naturalHeight || rect.height;

  // let clientX, clientY;
  // if(type === 'touch'){
  //   clientX =  event.changedTouches[0].clientX || event.touches[0].clientX;
  //   clientY =  event.changedTouches[0].clientY || event.touches[0].clientY;
  // } else {
  //   clientX = event.clientX;
  //   clientY = event.clientY;
  // }

  const { clientX, clientY } = getTouchClientPosition(event);

  const x = clientX - rect.left;
  const y = clientY - rect.top;

  const xPercent = `${(x / rect.width) * 100}%`;
  const yPercent = `${(y / rect.height) * 100}%`;

  overlayEl.style.backgroundPosition = `${xPercent} ${yPercent}`;
  // Maintain aspect ratio by sizing both axes
  overlayEl.style.backgroundSize = `${nW * zoomRatio}px ${nH * zoomRatio}px`;
  overlayEl.style.display = 'block';
}
function getTouchClientPosition(event) {
  let clientX = 0, clientY = 0;

  // Touch events (start, move, end)
  if (event.changedTouches && event.changedTouches.length > 0) {
    clientX = event.changedTouches[0].clientX;
    clientY = event.changedTouches[0].clientY;
  }
  // Fallback: some browsers only populate `touches`
  else if (event.touches && event.touches.length > 0) {
    clientX = event.touches[0].clientX;
    clientY = event.touches[0].clientY;
  }
  // Fallback for hybrid pointer events
  else if (typeof event.clientX === 'number' && typeof event.clientY === 'number') {
    clientX = event.clientX;
    clientY = event.clientY;
  }

  return { clientX, clientY };
}
function magnify(imageEl, zoomRatio, { mount } = {}) {
  const overlayEl = createOverlay(imageEl, { mount });

  // Interactions (listeners can be attached before append)
  overlayEl.addEventListener('mousemove', (e) =>
    moveWithHover(overlayEl, imageEl, e, zoomRatio)
  );
  // overlayEl.addEventListener('touchmove', (e) => {
  //   console.log(e,'touchmove');
  //   moveWithHover(overlayEl, imageEl, e, zoomRatio , 'touch')
  // }
  // );
  overlayEl.addEventListener('mouseleave', () => overlayEl._cleanup());
  overlayEl.addEventListener('click', (e) => {
    e.stopPropagation(); // prevent bubbling conflicts
    overlayEl._cleanup();
  });

  return overlayEl; // caller will await _readyPromise
}

// Global overlay state to prevent double-click issues
window.zoomState = window.zoomState || { currentOverlay: null, isSpawning: false };
let zoomState = window.zoomState;
function enableZoomOnHover(zoomRatio, { mount = 'body' } = {}) {
  zoomState = window.zoomState;

  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((imageEl) => {
    // Regular image click handler
    imageEl.addEventListener('click', async (evt) => {
      // If Flickity (or any drag) is present, prevent it from hijacking this click:
      if (typeof evt.cancelable !== 'boolean' || evt.cancelable) {
        evt.preventDefault();
      }
      evt.stopPropagation();

      // Check if already zoomed - if so, zoom out
      if (zoomState.currentOverlay) {
        zoomState.currentOverlay._cleanup();
        zoomState.currentOverlay = null;
        return;
      }

      const overlayEl = magnify(imageEl, zoomRatio, { mount });
      zoomState.currentOverlay = overlayEl;

      // Update cleanup to reset currentOverlay
      const originalCleanup = overlayEl._cleanup;
      overlayEl._cleanup = () => {
        originalCleanup();
        zoomState.currentOverlay = null;
      };

      // Wait until overlay is appended & positioned, then prime the first frame
      await overlayEl._readyPromise;
      moveWithHover(overlayEl, imageEl, evt, zoomRatio);
    });
  });

}

// Usage
// enableZoomOnHover(1.5, { mount: '.lalo-product-zoom' });

window.addEventListener('DOMContentLoaded', () => {
  const zoomIcon = document.querySelector('.product-zoom-icon');
  if (zoomIcon) {
    const handleIconClick = async (evt) => {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      // Find the associated image
      const imageEl = document.querySelector('.is-selected .image-magnify-hover') || document.querySelector('.is-active .image-magnify-hover');
      if (!imageEl) return;

      // Check if already zoomed - if so, zoom out
      if (zoomState.currentOverlay) {
        zoomState.currentOverlay._cleanup();
        zoomState.currentOverlay = null;
        return;
      }

      const overlayEl = magnify(imageEl, 1.5, { mount: '.lalo-product-zoom' });
      zoomState.currentOverlay = overlayEl;

      // Update cleanup to reset currentOverlay
      const originalCleanup = overlayEl._cleanup;
      overlayEl._cleanup = () => {
        originalCleanup();
        zoomState.currentOverlay = null;
      };

      // Wait until overlay is appended & positioned
      await overlayEl._readyPromise;

      // Create a synthetic event at the center of the image
      const rect = imageEl.getBoundingClientRect();
      const centerEvent = {
        clientX: rect.left + rect.width / 2,
        clientY: rect.top + rect.height / 2,
        cancelable: true
      };
      moveWithHover(overlayEl, imageEl, centerEvent, 1.5);
    };

    zoomIcon.addEventListener('click', handleIconClick);
  }
});
  // Click outside to close zoom
document.addEventListener("click", (evt) => {
  if (zoomState.currentOverlay) {
    const isClickOnImage = evt.target.closest(".image-magnify-hover");
    const isClickOnIcon = evt.target.closest(".product-zoom-icon");
    const isClickOnOverlay = evt.target.closest(".image-magnify-full-size");

    // If click is outside image, icon, and overlay, close zoom
    if (!isClickOnImage && !isClickOnIcon && !isClickOnOverlay) {
      zoomState.currentOverlay._cleanup();
      zoomState.currentOverlay = null;
    }
  }
});
